import { v4 as uuidv4 } from 'uuid';

/**
 * Session management utility for tracking user sessions across the application
 */
class SessionManager {
  private sessionId: string;

  constructor() {
    // Always create a new session on page load
    this.sessionId = uuidv4();
  }

  /**
   * Gets the current session ID
   */
  getSessionId(): string {
    return this.sessionId;
  }
}

// Export singleton instance
export const sessionManager = new SessionManager();
